import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EligibilityFileJobLogSchema = withDefaults({
  type: 'eligibility-file-job-log',
  objectExtensions: ['eligibility-file-job-log'],
  fields: [
    {
      kind: 'attribute',
      name: 'companyMeta',
    },
    {
      kind: 'attribute',
      name: 'counts',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'endTime',
    },
    {
      kind: 'attribute',
      name: 'fileName',
    },
    {
      kind: 'attribute',
      name: 'files',
    },
    {
      kind: 'attribute',
      name: 'jobErrors',
    },
    {
      kind: 'attribute',
      name: 'metaDiff',
    },
    {
      kind: 'attribute',
      name: 'plans',
    },
    {
      kind: 'attribute',
      name: 'previewCounts',
    },
    {
      kind: 'attribute',
      name: 'startTime',
    },
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'attribute',
      name: 'statusHistory',
    },
    {
      kind: 'attribute',
      name: 'strategy',
    },
    {
      kind: 'attribute',
      name: 'updatedBy',
    },
    {
      kind: 'attribute',
      name: 'uploadUrl',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'processId',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'eligibilityFileJobLogEntries',
      type: 'eligibility-file-job-log-entry',
      options: {
        async: false,
        inverse: 'eligibilityFileJobLog',
      },
    },
  ],
});

export default EligibilityFileJobLogSchema;
